import React, { Component } from 'react';

import { APIHandler, ContentHeader, BackImage, ShowcaseCollection, BackButton } from 'C4';
import PropTypes from 'prop-types';
import Breadcrumbs from 'react-router-dynamic-breadcrumbs';
import i18n from 'i18n-react';

const crumbRoutes = {
  '/main': 'Home',
  '/main/sell': 'Sell',
  '/main/promote/videos': 'Videos',
};

export default class ShowcaseCollectionCountryView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      header: [],
      stands: [],
    };
  }

  componentWillMount() {
    this.getStandsAndFloor();
  }

  getStandsAndFloor() {
    const params = new URLSearchParams(window.location.search);
    const { countryName } = this.props.match.params;
    const id = params.get('id');

    APIHandler.getExhibitionStandsUnsorted(id).then((res) => {
      const countryStands = res[0].tiles_sorted_country.filter(el => el.country.replace(/ /g, '-').toLowerCase() === countryName);
      this.setState({
        stands: countryStands,
        header: countryStands[0].country,
      });
    });
  }

  render() {
    const { header, stands } = this.state;
    const { category } = this.props.match.params;
    const params = new URLSearchParams(window.location.search);
console.log(params.get("header"));
console.log('ggasgas');
    let icon = '';
    if (header.icon) {
      icon = header.icon.replace('fa-', '');
    }

    if (stands.length === 0) {
      return <div />;
    }

    return (
      <div className="showcaseCollectionViewContainer">
        <BackImage />
        {params.get("header") === 'false' && (
          <style>
            {
              "\
        .header { display: none; } .showcaseContainer { margin-top: 5rem !important; }"
            }
          </style>
        )}
        <div className="showcaseContainer">
          {params.get('header') === 'false' && (
            <BackButton
              to="/"
              text={i18n.translate('general.back')}
            />
          )}
          {header && <ContentHeader header={header} icon={icon} />}\
          <Breadcrumbs
            mappedRoutes={crumbRoutes}
            WrapperComponent={props => <ul className="breadcrumb__List">{props.children}</ul>}
            LinkComponent={props => <li className="breadcrumb__item">{props.children}<span className="breadcrumb__separator">&#62;</span></li>}
            ActiveLinkComponent={props => <li className="breadcrumb__item--active">{props.children}</li>}
          />
          <ShowcaseCollection stands={stands} category={category} />
        </div>
      </div>
    );
  }
}

ShowcaseCollectionCountryView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape().isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

ShowcaseCollectionCountryView.defaultProps = {
  // headerSubtitle: '',
};
